module.exports = __webpack_public_path__ + "img/white_triangle.398ed814.png";